import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import Text from 'components/Atoms/Text'
import { EventItem } from 'components/Molecules/Events'

import LoadingSkeleton from './LoadingSkeleton'

const ListContainer = styled.div`
  margin-top: 30px;
  @media (min-width: ${props => props.theme.flexboxgrid.breakpoints.sm}rem) {
    margin-top: 40px;
  }
`

const ListContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`

const ListTitle = styled(Text)`
  margin-bottom: 8px;
  font-size: ${props => props.theme.font.size.mobile.small};
  @media (min-width: ${props => props.theme.flexboxgrid.breakpoints.sm}rem) {
    margin-bottom: 10px;
    font-size: ${props => props.theme.font.size.desktop.large};
  }
`

const ListItem = styled(EventItem)`
  flex: 0 100%;
  min-width: 0;
  @media (min-width: ${props => props.theme.flexboxgrid.breakpoints.sm}rem) {
    flex: 0 48%;
  }
`

const List = ({
  isBundleEvents,
  data,
  onSelect,
  showTitle,
  title,
  isLoading,
  application,
}) => {
  if (isLoading) return <LoadingSkeleton />

  return (
    <ListContainer>
      {showTitle && (
        <ListTitle className="bold">
          <span>{title}</span>
        </ListTitle>
      )}
      <ListContent>
        {data?.map((item, index) => (
          <ListItem
            key={index}
            {...item}
            isBundleEvents={isBundleEvents}
            application={application}
            onClick={() => onSelect(item)}
          />
        ))}
      </ListContent>
    </ListContainer>
  )
}

List.propTypes = {
  data: PropTypes.array,
  onSelect: PropTypes.func,
  showTitle: PropTypes.any,
  title: PropTypes.string,
  isBundleEvents: PropTypes.bool,
  isLoading: PropTypes.bool,
  application: PropTypes.string,
}

export { List, ListContainer, ListContent }
